export default "__VITE_ASSET__DflT0biJ__"